export default __webpack_public_path__ + "static/who-we-are-d30f7d6250aed0e390e84291386e80e4.jpg";